import { loadable } from "components/SpruceLoader";

export const ConfigurePatch = loadable(() => import("./configurePatch/index"));
